import React from "react";
import { Helmet } from "react-helmet-async";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

const Veneers = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className="container py-5 mt-5"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/decorative-veneers"
        />

        <title>{t("Veneers.seo.title")}</title>
        <meta name="description" content={t("Veneers.seo.description")} />
        <meta name="keywords" content={t("Veneers.seo.keywords")} />
        <meta property="og:title" content={t("Veneers.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("Veneers.seo.ogDescription")}
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://slimsmile.ps/images/veneers.jpg"
        />
        <meta
          property="og:url"
          content="https://slimsmile.ps/articles/veneers"
        />
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {t("Veneers.page.title")}
      </h1>
      <h5 className="text-center mb-5">{t("Veneers.page.subtitle")}</h5>
      <p className="text-center text-muted">{t("Veneers.page.center")}</p>

      <h2 className="mt-4">{t("Veneers.page.whatTitle")}</h2>
      <p>{t("Veneers.page.whatP1")}</p>
      <p>{t("Veneers.page.whatP2")}</p>
      <p>
        <strong>{t("Veneers.page.whatP3")}</strong>
      </p>

      <h2 className="mt-4">{t("Veneers.page.whenTitle")}</h2>
      <ul>
        {t("Veneers.page.whenList", { returnObjects: true }).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("Veneers.page.typesTitle")}</h2>
      <h3 className="mt-3">{t("Veneers.page.porcelain")}</h3>
      <ul>
        {t("Veneers.page.porcelainList", { returnObjects: true }).map(
          (item, i) => (
            <li key={i}>{item}</li>
          )
        )}
      </ul>

      <h3 className="mt-3">{t("Veneers.page.emax")}</h3>
      <ul>
        {t("Veneers.page.emaxList", { returnObjects: true }).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h3 className="mt-3">{t("Veneers.page.zirconia")}</h3>
      <ul>
        {t("Veneers.page.zirconiaList", { returnObjects: true }).map(
          (item, i) => (
            <li key={i}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Veneers.page.stepsTitle")}</h2>
      <ol>
        {t("Veneers.page.stepsList", { returnObjects: true }).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ol>

      <h2 className="mt-4">{t("Veneers.page.advantagesTitle")}</h2>
      <ul>
        {t("Veneers.page.advantagesList", { returnObjects: true }).map(
          (item, i) => (
            <li key={i}>{item}</li>
          )
        )}
      </ul>

      <h2 className="mt-4">{t("Veneers.page.careTitle")}</h2>
      <ul>
        {t("Veneers.page.careList", { returnObjects: true }).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("Veneers.page.messageTitle")}</h2>
      <p>
        <em>{t("Veneers.page.messageText")}</em>
      </p>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {t("Veneers.page.back")}
        </HashLink>
      </footer>
    </div>
  );
};

export default Veneers;
